import React, { useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, IcoArchive, IcoDownload, PopoverCentralAjuda, SafeHTML } from '../../../components';
import { CustomLabel, CustomTooltip, RenderLegend, graficoOptions } from './graficoOptions';
import { Bar, BarChart, Brush, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { BarCustom, CustomTooltipCustomProduto, PageLoadView, RenderLegendCustom, convertChart } from '../../../helpers';


export default ({ nlsContexto, labelgraf, imprimir }) => {
  const dispatch = useDispatch()
  const { grafico, graficoLoad } = useSelector(state=> state.csatconcorrentesprodutosState)
  const { titlePage, sistema } = useSelector(state=> state.layoutState)
  const [download, setDownload] = useState(false)

  console.error('ENTROU EM GRAFICO.JS');
  console.error(grafico, 'RESULTADO LIDO DE GRAFICO:');

  const nls = require(`./nls/${sistema.idioma}.json`)
  const erroaocarregar = nls.erroaocarregar;
  const semdadosparaexibir = nls.semdadosparaexibir;

  const idarray = [210];

  const handleDownload = async (e) => {
    setDownload(true)
    const chartdownload = await convertChart({id: 'graficos-chart-box', titlePage})
    setDownload(chartdownload)
  }

  const percentualsimbol = "% ";

  return (
    <>
      <div id='graficos-chart-box' className={`box-csatconcorrentesprodutos-graficos box-content ${download?'graficos-download':''}`}>
        <div className='graficos-chart-box-action'>
          <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray} />
          {!graficoLoad?<Button type='btn circle' color='primary' variant='outlined' onClick={()=> handleDownload()} title={nls.downloadgrafico}><IcoDownload /></Button>:null}
        </div>
        <div id='graficos-chart' className="box-csatconcorrentesprodutos-graficos-chart">
          <h3>{titlePage}</h3>
          {console.error(grafico.data,'DATAxxx')}
          <PageLoadView
           load={graficoLoad} 
           data={grafico.data}
           erroaocarregar={erroaocarregar}
           semdadosparaexibir={!imprimir ? nls.semdadosparaexibir : null}
           >
            <ResponsiveContainer width="100%" height="100%" >
              <BarChart
                width={graficoOptions.BarChart.width}
                height={graficoOptions.BarChart.height}
                data={grafico.data}
                margin={graficoOptions.BarChart.margin}
                
              >
                <CartesianGrid
                  stroke={graficoOptions.CartesianGrid.stroke} 
                  vertical={graficoOptions.CartesianGrid.vertical} 
                />
                {
                  grafico.data && !(grafico.labels.length <= graficoOptions.Brush.endIndex)?
                  <Brush
                    dataKey={graficoOptions.Brush.dataKey} 
                    height={graficoOptions.Brush.height} 
                    stroke={graficoOptions.Brush.stroke} 
                    startIndex={graficoOptions.Brush.startIndex}
                    endIndex={graficoOptions.Brush.endIndex}
                  />
                  :null
                }
                <XAxis 
                  dataKey={graficoOptions.XAxis.dataKey} 
                  stroke={graficoOptions.XAxis.stroke} 
                  axisLine={graficoOptions.XAxis.axisLine} 
                  tickLine={graficoOptions.XAxis.tickLine} 
                  fontSize={graficoOptions.XAxis.fontSize} 
                  tick={{ textAnchor: 'middle' }}
                />
                <YAxis 
                  unit={graficoOptions.YAxis.unit} 
                  stroke={graficoOptions.YAxis.stroke} 
                  axisLine={graficoOptions.YAxis.axisLine} 
                  tickLine={graficoOptions.YAxis.tickLine} 
                  fontSize={graficoOptions.YAxis.fontSize} 
                />

                {/* TIREI O CUSTOMTOOLTIP */}
                <Tooltip content={<CustomTooltipCustomProduto labels={grafico.labels} msgNA={nls.Dadonaodisponivel} labelgraf={labelgraf} exibirPercentual={true}/>} />
                <Legend content={<RenderLegendCustom  labels={grafico.labels} />} />

                
                <Bar
                  dataKey="Atual"
                  fill="Atual"
                  radius={graficoOptions.Bar.radius} 
                  label={<CustomLabel />}
                  shape={<BarCustom />}
                />
                <Bar
                  dataKey="Anterior"
                  fill="Anterior"
                  radius={graficoOptions.Bar.radius} 
                  label={<CustomLabel />}
                  shape={<BarCustom />}
                />


              </BarChart>
            </ResponsiveContainer>
          </PageLoadView>
        </div>

        {imprimir && (
        <div className='box-csatconcorrentesprodutos-graficos-chart-info'>
          <span><strong>{nls.media} </strong> {grafico.media}{percentualsimbol}</span>
          <span><strong>{nls.desviopadrao} </strong> {grafico.desvio}{percentualsimbol}</span>
        </div>
        )}



      </div>
      {
        grafico.analiseGrafica?
        <div className='box-csatconcorrentesprodutos-analise-grafica box-content'>
          <h3><IcoArchive/> {nls.Analise}</h3>

          {/* Substituído dangerouslySetInnerHTML pelo componente SafeHTML */}
          <SafeHTML html={grafico.analiseGrafica} />
        
        </div>
        :null
      }
    </>
  )
}
